(function (root, factory) {
    const api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    else root.SquaretalkTOC = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
    const slugify = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, '').replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';

    function collectHeadings(container) {
        const managedHeadings = [...container.querySelectorAll('h2, h3')];
        const managedSet = new Set(managedHeadings);
        const used = new Set([...container.ownerDocument.querySelectorAll('[id]')]
            .filter((node) => !managedSet.has(node))
            .map((node) => node.id));
        return managedHeadings.map((heading) => {
            const preferred = heading.id || slugify(heading.textContent.trim());
            if (!heading.id || used.has(heading.id)) {
                let id = preferred;
                let suffix = 2;
                while (used.has(id)) id = `${preferred}-${suffix++}`;
                heading.id = id;
            }
            used.add(heading.id);
            return {id: heading.id, level: Number(heading.tagName.slice(1)), label: heading.textContent.trim(), heading};
        });
    }

    function renderTOC({document, nav, headings}) {
        const list = document.createElement('ol');
        headings.forEach(({id, level, label}) => {
            const item = document.createElement('li');
            item.className = `st-toc__item st-toc__item--h${level}`;
            const link = document.createElement('a');
            link.href = `#${id}`;
            link.textContent = label;
            item.appendChild(link);
            list.appendChild(item);
        });
        nav.replaceChildren(list);
    }

    function initTOC({document}) {
        const content = document.querySelector('[data-article-content]');
        const shell = document.querySelector('[data-toc-shell]');
        const nav = document.querySelector('[data-toc]');
        const details = document.querySelector('[data-toc-details]');
        const layout = shell?.closest('.st-article-layout');
        if (!content || !shell || !nav) return null;
        const headings = collectHeadings(content);
        if (headings.length < 3) {
            shell.hidden = true;
            layout?.classList.remove('st-article-layout--with-toc');
            return null;
        }
        renderTOC({document, nav, headings});
        shell.hidden = false;
        layout?.classList.add('st-article-layout--with-toc');
        const view = document.defaultView;
        let observer = null;
        let removeMediaQueryListener = () => {};
        let removeToggleListener = () => {};
        if (details) {
            const mediaQuery = view?.matchMedia?.('(max-width: 991px)');
            details.open = !(mediaQuery?.matches ?? false);
            if (mediaQuery) {
                let desktopClosedByUser = false;
                const onToggle = () => {
                    if (!mediaQuery.matches) desktopClosedByUser = !details.open;
                };
                const syncDisclosure = ({matches}) => {
                    if (matches) details.open = false;
                    else if (!desktopClosedByUser) details.open = true;
                };
                details.addEventListener('toggle', onToggle);
                removeToggleListener = () => details.removeEventListener('toggle', onToggle);
                if (typeof mediaQuery.addEventListener === 'function') {
                    mediaQuery.addEventListener('change', syncDisclosure);
                    removeMediaQueryListener = () => mediaQuery.removeEventListener('change', syncDisclosure);
                } else if (typeof mediaQuery.addListener === 'function') {
                    mediaQuery.addListener(syncDisclosure);
                    removeMediaQueryListener = () => mediaQuery.removeListener(syncDisclosure);
                }
            }
        }
        if (typeof view?.IntersectionObserver === 'function') {
            const links = new Map([...nav.querySelectorAll('a')].map((link) => [link.hash.slice(1), link]));
            observer = new view.IntersectionObserver((entries) => {
                entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
                    links.forEach((link) => link.removeAttribute('aria-current'));
                    links.get(entry.target.id)?.setAttribute('aria-current', 'location');
                });
            }, {rootMargin: '-20% 0px -70% 0px'});
            headings.forEach(({heading}) => observer.observe(heading));
        }
        return {
            headings,
            destroy() {
                observer?.disconnect();
                removeMediaQueryListener();
                removeToggleListener();
            }
        };
    }

    return {slugify, collectHeadings, renderTOC, initTOC};
});
